export default __webpack_public_path__ + "static/media/cake-2.7a731795.jpeg";